import React, { useEffect, useRef, useState } from "react";

import "../../App.scss";

import Typography from "@mui/material/Typography";

import { useNavigate } from "react-router-dom";
import ProjectHandleling from "./ProjectHandeling";
import Logger from "../../Logger";
import ProjectMetadata, { UserReference } from "../../models/ProjectMetadata";
import { createEmptyProject } from "../../DemoData";
import { saveProject } from "../SaveProject";
import { showToast } from "../Toasts";
import BaseModelMap from "../../models/BaseModelMap";
import ZipStorageHandler from "../../persistence/ZipStorageHandler";
import { newId } from "../../models/BaseObject";
import Browser from "../../browser";
import BaseDialog from "../../modelDialogs/BaseDialog";
import ProjectLicense from "../../models/ProjectLicense";

const logger = new Logger();

export default function GPTProjectCard(props: { projectHandleling: ProjectHandleling }) {
  const { projectHandleling } = props;
  const navigate = useNavigate();
  const [examples, setExamples] = useState(new Array<string>());
  const [openNewProject, setOpenNewProject] = useState(false);
  const isMobile = Browser.isMobile();
  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    if (openNewProject) {
      state.dialogManager.openDialog(<NewProjectDialog />);
    }
  }, [openNewProject]);

  function NewProjectDialog(props: { nam?: string; desc?: string }) {
    const { nam, desc } = props;
    const [name, setName] = useState(nam || "");
    const [description, setDescription] = useState(desc || "");

    function clickCreateProject() {
      if (!navigator.onLine) {
        showToast({
          isError: true,
          text: state.translate(
            "loginPage.connectionInternetNotAailiable",
            "Die Verbindung zum Server kann nicht hergestellt werden. Bitte überprüfen Sie Ihr Internet.",
          ),
        });
        return;
      }
      logger.log("name, description", name, description);

      const project = new ProjectMetadata();
      project.setUserForNewProject();

      project.name = name;
      project.description = description;

      state.projectMetadata = project;
      // for license handeling
      state.projectMetadata.projectLicence = {
        invoiceIds: [] as Array<string>,
      };
      // the actual licenses live on state.projectLicense (not on projectMetadata.projectLicence),
      // so they must be reset here too, otherwise the copy inherits the original project's licenses
      state.projectLicense = new ProjectLicense({}, state.root);
      // createDemoData(state);
      createEmptyProject(state);

      saveProject();
      state.navigate("/app");
    }

    return (
      <div>
        <BaseDialog
          title={state.translate("homePage.createProject", "Neues KNX Projekt anlegen")}
          onOk={() => {
            if (name != "") {
              const names: Array<string> = [];

              if (!state.noDoubleValue.doubleName(name, names)) {
                if (state.allProjectsMap) {
                  state.allProjectsMap.forEach((project: any, id: any) => {
                    names.push(project.name);
                  });
                }
                clickCreateProject();
                return true;
              } else {
                state.dialogManager.openDialog(
                  <BaseDialog
                    title={state.translate("step0.projectNameAlreadyUsed", "Projektname schon vorhanden")}
                    onOk={() => {
                      state.dialogManager.openDialog(<NewProjectDialog desc={description} />);
                      return false;
                    }}
                    okCaption={state.translate("ok", "Ok")}
                    noAbortButton={true}
                  >
                    <div style={{ padding: "20px" }}>
                      {state.translate(
                        "step0.projectNameAlreadyUsedText",
                        "Sie haben einen schon vorhandenen Namen eingegeben! Bitte geben sie einen neuen ein um fort zu führen",
                      )}
                    </div>
                  </BaseDialog>,
                );

                return false;
              }
            } else {
              state.dialogManager.openDialog(
                <BaseDialog
                  title={state.translate("step0.projectName?", "Projektname?")}
                  onOk={() => {
                    state.dialogManager.openDialog(<NewProjectDialog desc={description} />);
                    return false;
                  }}
                  okCaption={state.translate("ok", "Ok")}
                  noAbortButton={true}
                >
                  <div style={{ padding: "20px" }}>
                    {state.translate(
                      "step0.noNameentered",
                      "Sie haben keinen Namen eingegeben! Bitte geben sie einen ein um fort zu führen",
                    )}
                  </div>
                </BaseDialog>,
              );
              return false;
            }
          }}
          onClose={() => {
            setOpenNewProject(false);
            return true;
          }}
        >
          <div style={{ padding: "20px" }}>
            <tbody>
              <tr>
                <td>{state.translate("name", "Name")}:</td>
                <td style={{ paddingRight: "5px" }}>
                  <input
                    className="input"
                    placeholder={state.translate("coverPage.projectName", "Projektname")}
                    type={"text"}
                    value={name}
                    maxLength={state.maxCharLimit.text}
                    autoFocus={true}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td style={{ paddingRight: "5px" }}>
                  {state.translate("listComponents.actorProductDescription", "Beschreibung")}:
                </td>
                <td>
                  <input
                    className="input"
                    type={"text"}
                    value={description}
                    maxLength={state.maxCharLimit.largeText}
                    onChange={(e) => {
                      setDescription(e.target.value);
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </div>
        </BaseDialog>
      </div>
    );
  }
  function importFile(event: any) {
    const file = event.target.files[0];
    let fr = new FileReader();
    fr.onload = receivedBlob;
    // fr.readAsText(file);
    fr.readAsArrayBuffer(file);
  }

  // function receivedText(e: any) {
  //   let lines = e.target.result;
  //   var newArr = JSON.parse(lines);
  //   logger.log("newArr ", newArr);
  //   newArr.id = Guid.create().toString();
  //   alert("Import project is Disabled");
  //   // dbHandler.importToDB(newArr);
  // }

  async function receivedBlob(e: any) {
    let blob = new Blob([e.target.result]);

    const z = new ZipStorageHandler();
    await z.setBlob(blob);

    state.clear();

    const projecMetadataJson = await z.loadProjectMetadata("");
    state.projectMetadata.fromJSON(projecMetadataJson);
    const ok = await z.loadProjectItems(state.projectMetadata.id);

    let newProjectName = projecMetadataJson?.name + " (importiert)";
    const projectnames = new Array<string>();
    state.allProjectsMap.forEach((project) => {
      if (project.id != state.projectMetadata.id) {
        projectnames.push(project.name);
      }
    });
    while (state.noDoubleValue.doubleName(newProjectName, projectnames)) {
      newProjectName = state.noDoubleValue.getCopiedStringText(newProjectName);
    }

    state.projectMetadata.name = newProjectName;
    state.projectMetadata.id = newId();
    state.root.id = state.projectMetadata.id;
    state.projectMetadata.users = new Array<UserReference>();
    state.projectMetadata.setUserForNewProject();

    state.projectMetadata.lastModifiedOnServer = new Date();
    // for license handeling
    state.projectMetadata.projectLicence = {
      invoiceIds: [] as Array<string>,
    };
    // the actual licenses live on state.projectLicense (not on projectMetadata.projectLicence),
    // so they must be reset here too, otherwise the copy inherits the original project's licenses
    state.projectLicense = new ProjectLicense({}, state.root);

    saveProject();
    state.navigate("/app");
  }

  const style: any = {
    display: "flex",
    flexDirection: "row",
    gap: "3px",
    alignItems: "center",
  };
  ///////////////////////////////////
  //// for gpt
  //////////////////////////////
  async function init() {
    const ss = new Array<string>();
    const uiLanguage = state.settings.uiLanguage.startsWith("en") ? "en" : "de";
    for (let i = 0; i < 4; i++) {
      try {
        let res = await fetch(`data/assistant/${uiLanguage}/specs/spec${i}.txt`);
        const txtSpec1 = await res.text();
        ss.push(txtSpec1);
      } catch (ex) {}
    }

    setExamples(ss);
  }

  function Content() {
    const questionRef = useRef<HTMLTextAreaElement>(null);
    const options = new Array<any>();

    function onChange() {
      if (questionRef.current?.value) {
        const s = questionRef.current?.value;
      }
    }

    function executeQuestion() {
      if (!navigator.onLine) {
        showToast({
          isError: true,
          text: state.translate(
            "loginPage.connectionInternetNotAailiable",
            "Die Verbindung zum Server kann nicht hergestellt werden. Bitte überprüfen Sie Ihr Internet.",
          ),
        });
        return;
      }
      logger.log("create new Project with gpt input:");
      if (!questionRef.current?.value.replace("/n", "").trim()) {
        showToast({
          text: state.translate(
            "gptProjectCard.emptyTextField",
            "Projekt kann nicht erstellt werden, da noch nichts beschrieben wurde!",
          ),
        });
        return;
      }
      function getName(): string {
        const zeichenkette = state.translate("gptProjectCard.projectName", "Eigenes Projekt");
        let int = 0;
        let name = zeichenkette;

        const projectBaseModelMap = new BaseModelMap<ProjectMetadata>(ProjectMetadata, undefined, undefined);
        state.allProjectsMap.forEach((project) => {
          projectBaseModelMap.push(project);
        });
        projectBaseModelMap.sortBy2("name").forEach((project) => {
          if (int != 0) {
            name = zeichenkette + ` ${int}`;
          }
          if (name == project.name) {
            int++;
          }
        });
        return name;
      }

      const project = new ProjectMetadata();
      project.setUserForNewProject();

      project.name = getName();
      project.description = state.translate(
        "gptProjectCard.projectDescription",
        "dieses Projekt wurde mithilfe unseren assistenten erstellt",
      );
      project.gptToRunText = questionRef.current?.value;

      state.projectMetadata = project;

      createEmptyProject(state);
      // for license handeling
      state.projectMetadata.projectLicence = {
        invoiceIds: [] as Array<string>,
      };
      // the actual licenses live on state.projectLicense (not on projectMetadata.projectLicence),
      // so they must be reset here too, otherwise the copy inherits the original project's licenses
      state.projectLicense = new ProjectLicense({}, state.root);
      saveProject();
      state.navigate("/app");
    }

    let i = 0;
    options.push(<option key={`${i++}`}>{state.translate("gptProjectCard.textBlocks", "Textbausteine")}</option>);
    examples.forEach((e) => {
      const i1 = e.indexOf("\n");
      const value = e.substring(i1).trim();
      const title = e.substring(0, i1).trim();

      options.push(
        <option value={value} key={`${i++}`}>
          {title}
        </option>,
      );
    });
    const placeHolder = `${state.translate("gptProjectCard.placeholderLine1", "Beschreibe dein Projekt!")}
${state.translate("gptProjectCard.placeholderLine2", "Welche Etagen und Räume soll es bekommen?")}
${state.translate("gptProjectCard.placeholderLine3", "Welche Leuchten sollen die Räume beinhalten?")}`;

    return (
      <div style={{ position: "relative", padding: "10px" }}>
        {/* <CardContent> */}
        <Typography
          variant="h5" // no itx
          component="div" // no itx
        >
          {state.translate("homePage.describeNewProject", "Neues Projekt beschreiben")}
        </Typography>
        {/* </CardContent> */}

        <Typography
          variant="h5" // no itx
          component="div" // no itx
          style={{ fontSize: "15px", paddingTop: "10px" }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <textarea
              style={{
                flexGrow: "1",
                height: "200px",
                minHeight: "75px",
                maxHeight: "400px",
                borderRadius: "5px",
                width: "100%",
                padding: "5px 10px",
                borderColor: "transparent",
                marginBottom: "10px",
              }}
              className="question"
              ref={questionRef}
              placeholder={placeHolder}
              //onChange={onChange}
            />

            <div style={{ display: "flex", flexDirection: "row" }}>
              <button className="button" style={{ zIndex: "2", backgroundColor: "var(--primary-color-light)" }}>
                <select
                  className="select"
                  style={{ width: "100%", backgroundColor: "transparent", border: "none" }}
                  onChange={(ev: any) => {
                    if (questionRef.current) {
                      const s = ev.target.options[ev.target.selectedIndex].value;
                      questionRef.current.value = questionRef.current.value + `${s}\n\n`;
                      ev.target.selectedIndex = 0;
                      onChange();
                      setTimeout(() => {
                        questionRef.current?.focus();
                      }, 100);
                    }
                  }}
                >
                  {options}
                </select>
              </button>
              <button
                className="button"
                onClick={executeQuestion}
                style={{
                  backgroundColor: "var(--primary-color-light)",
                  textAlign: "left",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {state.translate("gptProjectCard.createProject", "Projekt erstellen")}
              </button>
            </div>
          </div>
        </Typography>
      </div>
    );
  }

  ///////////////////////////////////////////////////////////////////////////////

  return (
    <div
      id={"GPTProjectCard"} // no itx
      key={"GPTProjectCard"} // no itx
      className={"projectSelectionCard"}
      style={{ backgroundColor: "var(--primary-color-light)" }}
    >
      <Content />
    </div>
  );
}
